module.exports = __webpack_public_path__ + "img/bottom-text-th.ca93b7f7.webp";